// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.fixed-container {
    position: fixed; 
    top: 80px; 
    right: 0; 
    width: 330px; 
    background-color: #fff; 
    /* border-radius: 8px;  */
    z-index: 1200;
    overflow-y: auto; /* Cho phép cuộn dọc */
    /* max-height: calc(100vh - 60px); } */
}

.confirm-button {
    background-color: #0069ff;
    color: white;
    border: none;
    padding: 12px 20px;
    border-radius: 5px;
    font-size: 1rem;
    width: 100%;
    cursor: pointer;
    transition: background-color 0.3s;
}

.confirm-button:hover {
    background-color: #0056b3;
}

  .cart-container {
    background: white;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5px;
    /* box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); */
  }
  

.progress-bar {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 10px 0;
    width: 100%; 
    /* box-sizing: border-box;  */
}
  
  .step {
    flex: 1 1; /* Các bước chiếm đều không gian */
    text-align: center;
    padding: 10px 0;
    color: #888;
    font-weight: bold;
    white-space: nowrap; /* Ngăn việc xuống dòng */
  }
  
  .step.active {
    color: #007bff;
    border-bottom: 2px solid #007bff;
  }
  
  .step:not(:last-child) {
    margin-right: 10px; /* Khoảng cách giữa các bước */
  }
  
  /* Tiêu đề */
  .cart-title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  
  /* Bảng giỏ hàng */
  /* Định dạng cho bảng */
.cart-table {
    width: 100%;
    margin: 20px 0;
}

.cart-table thead {
    background-color: rgba(33, 37, 41, 0.75); 
    color: white; 
}

.cart-table th, .cart-table td {
    padding: 10px;
    text-align: center;
    border: 1px solid #ddd; 
}

.delete-button {
    background-color: red;
    color: white;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 5px;
}

.delete-button:hover {
    background-color: darkred;
}

  
  .delete-button {
    background-color: transparent;
    border: 1px solid red;
    color: red;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 3px;
  }
  
  .cart-summary {
    margin-bottom: 20px;
    font-size: 14px;
    text-align: right;
  }
  
  .summary-line {
    display: flex;
    justify-content: space-between;
    margin: 5px 0;
  }
  
  /* Mã giảm giá */
  .discount-section {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  
  .discount-section input {
    flex: 1 1;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-right: 10px;
  }
  
  .discount-section button {
    padding: 10px 15px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .spinner-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5); /* Nền tối mờ */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999; /* Đảm bảo spinner luôn hiển thị trên cùng */
}
.cart-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.cart-table th {
  font-weight: bold;
}

.cart-table td {
  vertical-align: middle; /* Căn giữa theo chiều dọc */
}

/* Nút Xóa */
.delete-button {
  padding: 5px 10px;
  font-size: 12px;
  color: red;
  border: 1px solid red;
  background-color: white;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
}

.delete-button:hover {
  background-color: red;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Cart/Cart.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,gBAAgB,EAAE,sBAAsB;IACxC,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;EAEE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gDAAgD;EAClD;;;AAGF;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,6BAA6B;AACjC;;EAEE;IACE,SAAO,EAAE,kCAAkC;IAC3C,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,mBAAmB,EAAE,yBAAyB;EAChD;;EAEA;IACE,cAAc;IACd,gCAAgC;EAClC;;EAEA;IACE,kBAAkB,EAAE,8BAA8B;EACpD;;EAEA,YAAY;EACZ;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,kBAAkB;EAClB,uBAAuB;AACzB;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;;EAGE;IACE,6BAA6B;IAC7B,qBAAqB;IACrB,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,aAAa;EACf;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,oCAAoC,EAAE,eAAe;IACrD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,4CAA4C;AAC/D;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB,EAAE,4BAA4B;AACtD;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd","sourcesContent":["\n.fixed-container {\n    position: fixed; \n    top: 80px; \n    right: 0; \n    width: 330px; \n    background-color: #fff; \n    /* border-radius: 8px;  */\n    z-index: 1200;\n    overflow-y: auto; /* Cho phép cuộn dọc */\n    /* max-height: calc(100vh - 60px); } */\n}\n\n.confirm-button {\n    background-color: #0069ff;\n    color: white;\n    border: none;\n    padding: 12px 20px;\n    border-radius: 5px;\n    font-size: 1rem;\n    width: 100%;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.confirm-button:hover {\n    background-color: #0056b3;\n}\n\n  .cart-container {\n    background: white;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 5px;\n    /* box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); */\n  }\n  \n\n.progress-bar {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    padding: 10px 0;\n    width: 100%; \n    /* box-sizing: border-box;  */\n}\n  \n  .step {\n    flex: 1; /* Các bước chiếm đều không gian */\n    text-align: center;\n    padding: 10px 0;\n    color: #888;\n    font-weight: bold;\n    white-space: nowrap; /* Ngăn việc xuống dòng */\n  }\n  \n  .step.active {\n    color: #007bff;\n    border-bottom: 2px solid #007bff;\n  }\n  \n  .step:not(:last-child) {\n    margin-right: 10px; /* Khoảng cách giữa các bước */\n  }\n  \n  /* Tiêu đề */\n  .cart-title {\n    text-align: center;\n    font-size: 18px;\n    font-weight: bold;\n    margin-bottom: 20px;\n  }\n  \n  /* Bảng giỏ hàng */\n  /* Định dạng cho bảng */\n.cart-table {\n    width: 100%;\n    margin: 20px 0;\n}\n\n.cart-table thead {\n    background-color: rgba(33, 37, 41, 0.75); \n    color: white; \n}\n\n.cart-table th, .cart-table td {\n    padding: 10px;\n    text-align: center;\n    border: 1px solid #ddd; \n}\n\n.delete-button {\n    background-color: red;\n    color: white;\n    border: none;\n    padding: 5px 10px;\n    cursor: pointer;\n    border-radius: 5px;\n}\n\n.delete-button:hover {\n    background-color: darkred;\n}\n\n  \n  .delete-button {\n    background-color: transparent;\n    border: 1px solid red;\n    color: red;\n    padding: 5px 10px;\n    cursor: pointer;\n    border-radius: 3px;\n  }\n  \n  .cart-summary {\n    margin-bottom: 20px;\n    font-size: 14px;\n    text-align: right;\n  }\n  \n  .summary-line {\n    display: flex;\n    justify-content: space-between;\n    margin: 5px 0;\n  }\n  \n  /* Mã giảm giá */\n  .discount-section {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n  }\n  \n  .discount-section input {\n    flex: 1;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    margin-right: 10px;\n  }\n  \n  .discount-section button {\n    padding: 10px 15px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  .spinner-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.5); /* Nền tối mờ */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999; /* Đảm bảo spinner luôn hiển thị trên cùng */\n}\n.cart-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n}\n\n.cart-table th {\n  font-weight: bold;\n}\n\n.cart-table td {\n  vertical-align: middle; /* Căn giữa theo chiều dọc */\n}\n\n/* Nút Xóa */\n.delete-button {\n  padding: 5px 10px;\n  font-size: 12px;\n  color: red;\n  border: 1px solid red;\n  background-color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  text-align: center;\n}\n\n.delete-button:hover {\n  background-color: red;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
